import React, { useEffect, useRef, useState } from 'react'
import styles from './pastSchedule.module.css'

import { useNavigate } from "react-router-dom";
import cleanerOne from "../../../assets/cleanerOne.png";
import cleanerTwo from "../../../assets/cleanerTwo.png";
import plusIcon from "../../../assets/plusIcon.png";
import { List } from "antd";
import { AntdDropdown, SearchInput } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ScheduleMiddleware from '../../../store/Middlewares/ScheduleMiddleware';
import moment from 'moment';
import { roles } from '../../../config/roles';


const PastSchedule = () => {

    const navigate = useNavigate();
    const dummyChecklist = [
        {
            id: 1,
            date: "06-29-2023",
            customerName: "Mr. James",
            cleanerName: "Jason Smith",
            category: 'Custodial Engineer',
            Time: "10:00 PM-05:00 PM",
            Hours: "5 Hr 30 Min",
            Location: '8675, New York City'
        },
        {
            id: 2,
            date: "06-29-2023",
            customerName: "Mr. James",
            cleanerName: "Jason Smith",
            category: 'Custodial Engineer',
            Time: "10:00 PM-05:00 PM",
            Hours: "5 Hr 30 Min",
            Location: '8675, New York City'
        }
    ];

    useEffect(() => {
        getLanguage();
        getPastSchedule();
    }, []);



    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const user = useSelector(state => state.AuthReducer.user);
    const timeout = useRef(null);
    const [search, setSearch] = useState('');
    const PastScheduleList = useSelector(
        state => state.ScheduleReducer.PastScheduleList,
    );
    const PastScheduleListPagination = useSelector(
        state => state.ScheduleReducer.PastScheduleListPagination,
    );
    const role = localStorage.getItem('role')

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language);
        } catch (e) {
            console.log(e);
        }
    };

    const getPastSchedule = () => {
        let data = {
            next_page_url: undefined,
            search: search,
            Status: 'completed',
        };
        dispatch(ScheduleMiddleware.getPastSchedule(data));
    };


    const onPressLoadMore = () => {
        let data = {
            search: search,
            next_page_url: PastScheduleListPagination?.links?.next,
            Status: 'completed',
        };
        dispatch(ScheduleMiddleware.getPastSchedule(data));
    };

    const onSearchPastSchedule = text => {
        let data = {
            search: text,
            next_page_url: undefined,
            Status: 'completed',
        };
        setSearch(text);
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            dispatch(ScheduleMiddleware.getPastSchedule(data));
        }, 1000);
    };


    const handleChange = value => {
        console.log(value);
        if (value == 'Time_Sheet') {
            navigate('/schedule/TimeSheet')
        }
        else if (value == 'Calendar_Schedule') {
            navigate('/schedule/Calendar')
        }

    };

    const loadMore =
        PastScheduleListPagination?.links?.next ? (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                    display: 'flex', justifyContent: 'center'
                }}
            >
                <button onClick={onPressLoadMore} className={styles.loadMore_button}>
                    Load More
                </button>
            </div>
        ) : null;

    return (
        <div className={styles.createChecklist_mainContainer}>
            <div className={styles.filterCont}>
                <div className={styles.filterItem}>
                    <SearchInput onChange={(e) => onSearchPastSchedule(e.target.value)} placeholder={"Search"} style={{ width: '100%' }} />
                </div>
            </div>
            <List
                grid={{
                    gutter: 16,
                    //   xs: 2,
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 2,
                    xxl: 2,
                }}
                // className={styles.createChecklist_list}
                dataSource={PastScheduleList}
                footer={loadMore}
                style={{ width: '100%' }}
                renderItem={(item) => (
                    <div key={item?.id} className={styles.createChecklist_listItem} onClick={() => {
                        if(role == roles.contractor){
                            navigate('/schedule/PastSchedule/Details', { state: item })
                        }
                    }}>
                        <div className={styles.createChecklist_context}>
                            <div className={styles.createChecklist_heading}>
                                <h3>{moment(item?.date).format('MM-DD-YYYY')}</h3>
                            </div>
                            <div className={styles.dataCont} style={{width:role == roles.customer && '67%'}}>
                                {role != roles.customer &&
                                    <div style={{ width: '100%' }}>
                                        <p className={styles.schedule_heading}>{t("Customer Name")}</p>
                                        <p className={styles.createChecklist_para}>{item?.customer_name}</p>
                                    </div>
                                }
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Cleaner Name")}</p>
                                    <p className={styles.createChecklist_para}>{item?.cleaner_name}</p>
                                </div>
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Category")}</p>
                                    <p className={styles.createChecklist_para}>{item?.service_type}</p>
                                </div>
                            </div>
                            <div className={styles.dataCont}>
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Time")} </p>
                                    <p className={styles.createChecklist_para}>{moment('01 jan 1940 ' + item?.start_time).format('LT') + ' - ' + moment('01 jan 1940 ' + item?.end_time).format('LT')}</p>
                                </div>
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Hours")}</p>
                                    <p className={styles.createChecklist_para}>{item?.working_hours}</p>
                                </div>
                                <div style={{ width: '100%' }}>
                                    <p className={styles.schedule_heading}>{t("Location")}</p>
                                    <p className={styles.createChecklist_para}>{item?.location?.address}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

export default PastSchedule